import { Avatar, Column, Timestamp } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import type {
  SearchCompanyHit,
  SearchCompanyResult,
  SearchUserHit,
  SearchUserResult,
} from 'lib-shared-types-api';

import styles from '../../../../../searchResults.module.scss';
import { SearchResultsPagination } from '../../../../pagination/searchResultsPagination';
import { SearchResult } from '../../../../result/searchResult';

type ContactResultProps = {
  result?: SearchUserResult | SearchCompanyResult;
  selectedId?: string;
  onSelectHit?: (hit: SearchUserHit | SearchCompanyHit) => void;
};

export const ContactResult = ({
  result,
  selectedId,
  onSelectHit,
}: ContactResultProps): JSX.Element => {
  const getRowClassName = (hit: SearchUserHit | SearchCompanyHit) =>
    classnames({
      [styles.rowClickable]: true,
      [styles.rowSelected]: hit.id === selectedId,
    });

  return (
    <>
      <Column.Row scrollable noVerticalPadding noHorizontalPadding>
        {result?.hits.map((hit) => {
          const title =
            (result.hits_type === 'user' ? hit.display_name : hit.name) ||
            'Anonymous';
          const email = result.hits_type === 'user' ? hit.email : '';
          const phoneNumber =
            result.hits_type === 'user' ? hit.phone_number : '';
          const separator = ' · ';
          const metadata =
            email && phoneNumber ? (
              <span>
                {email} {separator} {phoneNumber}
              </span>
            ) : (
              email || phoneNumber || ''
            );

          return (
            <SearchResult
              key={hit.id}
              className={getRowClassName(hit)}
              content={{
                title,
                message: (
                  <span>
                    {metadata} {metadata && separator}
                    <span key="ts" className="search-result-timestamp">
                      {'Created '}
                      <Timestamp relative time={hit.created_at} />
                    </span>
                  </span>
                ),
                avatar: <Avatar user={hit} />,
              }}
              onClick={() => onSelectHit?.(hit)}
            />
          );
        })}
      </Column.Row>

      <Column.Row noVerticalPadding noHorizontalPadding borderTop>
        <SearchResultsPagination
          pageCount={result?.nb_pages ?? 1}
          currentPage={result?.page ?? 0}
        />
      </Column.Row>
    </>
  );
};
